// eslint-disable-next-line unicorn/prevent-abbreviations
import template from './dev5.html';
import controller from './dev5.controller';
import './dev5.scss';

export default {
	template,
	controller,
	title: 'dev5',
	path: '/dev5',
	onlyDev: true,
	controllerAs: 'ctrl',
};
